<template>
  <el-row :gutter="10">
    <el-col :span="14">
      <PackageSizeTable :orderCode="orderCode" />
    </el-col>
    <el-col :span="10">
      <PackageDocTable :orderCode="orderCode" />
    </el-col>
  </el-row>
</template>
<script>
import PackageSizeTable from './components/package-size'
import PackageDocTable from './components/package-doc'
export default {
  components: { PackageSizeTable, PackageDocTable },
  props: {
    orderCode: { type: String, default: '' },
  },
}
</script>
